<template lang="pug">
.filters(:class="{ 'filters--mobile-drawer-active': mobileOpen }")
	.filters__heading {{ results.totalResultCount }} Results
	button.filters__toggle.btn(type="button", @click="mobileOpen = !mobileOpen") {{ settings.filterText }}
	.filters__inner(@click.self="mobileOpen = false")
		.filters__content
			button.filters__close(type="button", @click="mobileOpen = false") Close
			.filters__form
				SearchFiltersGroup(
					v-for="filterGroup in filters",
					:key="filterGroup.id",
					:filterGroup="filterGroup")
				button.filters__btn.btn(@click="submitFilters") {{ settings.filterButtonText }}
</template>

<script>
import { mapGetters } from "vuex";

import SearchFiltersGroup from "./SearchFiltersGroup";
export default {
	name: "SearchFilters",
	components: {
		SearchFiltersGroup,
	},
	data: function () {
		return {
			mobileOpen: false,
		};
	},
	computed: {
		...mapGetters(["settings", "results", "searchQuery"]),
		filters() {
			return this.results.filters.filter(g => {
				if (g.visible) return true;
				return g.filters.some(f => f.selected);
			});
		},
	},
	methods: {
		submitFilters() {
			this.$emit("submitfilters", this.getFilterQuerystring());
		},
		getFilterQuerystring() {
			const ids = [];
			this.searchQuery.filters.forEach((parent) => {
				const group = parent.filters
					.filter((c) => c.selected == true)
					.map((a) => a.id);

				if (group.length > 0) {
					ids.push(group);
				}
			});

			return ids.join(",");
		},
	},
};
</script>

<style lang="scss" scoped>
.filters {
	display: flex;
	flex-direction: column;
	padding-top: 1.25rem;
	&__toggle {
		width: 100%;
		color: $white;
		background: $primaryPurple;
		padding: 0.9375rem 1.5rem;
		font-size: 1rem;
		margin-bottom: 2.5rem;
		border-radius: 2rem;
        border-width: .1rem;
        border-style: solid;
        border-color: #fff;
		&:hover {
			background: darken($primaryPurple, 10%);
		}
		@include mq(lg) {
			display: none;
		}
	}

	&__inner {
		display: flex;
		flex-direction: column;
		position: fixed;
		top: 0;
		right: 0;
		bottom: 0;
		width: 300px;
		transition: transform 0.25s ease;
		transform: translateX(100%);
		z-index: 9999;

		&::before,
		&::after {
			content: "";
			top: 0;
			right: 0;
			bottom: 0;
		}

		&::before {
			position: absolute;
			z-index: -1;
			left: 0;
			background: $white;
		}

		&::after {
			position: fixed;
			z-index: -2;
			width: 100vw;
			height: 100vh;
			cursor: pointer;
			background: rgba($black, 0.85);
			transition: 0.25s ease;
			pointer-events: none;
			visibility: hidden;
			opacity: 0;
			transform: translateX(-300px);
		}

		.filters--mobile-drawer-active & {
			transform: translateX(0);

			&::after {
				visibility: visible;
				opacity: 1;
				pointer-events: all;
				transform: translateX(0);
			}
		}

		@include mq(lg) {
			position: relative;
			height: auto;
			width: auto;
			transform: none;
			transition: none;
			z-index: 0;
			box-shadow: none;
			&::before,
			&::after {
				display: none;
			}
		}

		> *:last-child {
			margin-bottom: 0;
		}
	}

	&__content {
		display: flex;
		flex-direction: column;

		@include mqdn(lg) {
			overflow-y: auto;
			height: 100%;
			width: 100%;
			padding: 0 0.9375rem;
		}
	}

	&__close {
		@include clean(button);
		display: flex;
		padding: 1rem 3rem;
		margin: 0 -0.9375rem 1rem;
		justify-content: flex-end;
		align-items: center;
		position: relative;
		transition: 0.25s ease;
		font-size: 1rem;
		color: $gray;

		&:before,
		&:after {
			content: "";
			position: absolute;
			top: 0;
			right: 0.9375rem;
			bottom: 0;
			height: 1rem;
			width: 2px;
			background-color: currentColor;
			margin: auto 0;
		}

		&:before {
			transform: rotate(45deg);
		}

		&:after {
			transform: rotate(-45deg);
		}

		&:hover {
			background: $darkGray;
			color: $white;
		}

		@include mq(lg) {
			display: none;
		}
	}

	&__heading {
		font-family: "Roboto",sans-serif;
		color: $black;
		font-weight: 400;
		margin: 0 0 0.75rem !important;
		font-size: 0.875rem;
	}

	&__form {
		display: flex;
		flex-direction: column;
		padding: 0;
		margin: 0;
	}

	&__btn {
		width: 100%;
		padding: 0.9375rem 1.5rem;
		font-size: 1rem;
		margin-bottom: 2.5rem;
		border-radius: 2rem;
        border-width: .1rem;
        border-style: solid;
        border-color: #fff;
		flex: 0 0 auto;
		align-self: stretch;
		@include mq(lg) {
			margin-bottom: 0;
		}
	}
}
</style>